import { useState } from "react";
import styles from "./LinkPageHeader.module.scss";

interface ILinkPageHeaderProps {
  studioName: string;
  logoUrl: string | null;
}

/**
 * The studio's identity at the top of the page. A studio without a logo gets its name alone —
 * an invented placeholder mark would read as the studio's branding without being it.
 */
export const LinkPageHeader = ({
  studioName,
  logoUrl,
}: ILinkPageHeaderProps) => {
  // The logo link is a time-limited storage URL. If it has expired, dropping the badge is
  // better than leaving a broken image at the top of the studio's shared page.
  const [logoFailed, setLogoFailed] = useState(false);

  const showLogo = !!logoUrl && !logoFailed;

  return (
    <header className={styles.root}>
      {showLogo && (
        <div className={styles.root_badge}>
          <img
            className={styles.root_badge_image}
            src={logoUrl!}
            alt={studioName}
            onError={() => setLogoFailed(true)}
          />
        </div>
      )}

      <h1 className={styles.root_name}>{studioName}</h1>
    </header>
  );
};
